import defaults from './defaults';
import features from './features';
import server from './server';
import tempcheckinterval from './tempcheckinterval';
import tempreportconfig from './tempreportconfig';

export default {
  defaults,
  features,
  server,
  tempcheckinterval,
  tempreportconfig,
};
